import React from 'react'
import PageWrapper from '../../Components/Other/PageWrapper'
import { useEffect } from 'react';
import DetailHeader from '../../Components/DiseaseDetail/DetailHeader'

function Chickenpox(props) {
    useEffect(() => {

    })
    return (
        <PageWrapper className={"dis-07-chickenpox-page"}>
            <>
                {/*?php include 'header.php'; ?*/}
                <div className="pageWrapper">
                <DetailHeader diseaseName={"Chickenpox"}></DetailHeader>
                    <div className="MainContent">
                        <div className="container">
                            <div className="page-rte">
                                <p>
                                    Chickenpox is an infection caused by the varicellazoster virus. It
                                    causes an itchy rash with small, fluidfilled blisters. Chickenpox is
                                    highly contagious
                                    
                                </p>
                                <div className="row">
                                    <div className="col-12 textCenter">
                                        <img src={require("../../img/Disease/Chickenpox/1.png")} alt="Chickenpox" />
                                    </div>
                                </div>

                                <p>
                                    <b>Symptoms</b>
                                </p>
                                <ul className="listUnstyle">
                                    <li>Blister</li>
                                    <li>Scab</li>
                                    <li>Ulcers, or red spots</li>
                                    <li>fatigue</li>
                                    <li>fever or loss of appetite</li>
                                    <li>Headache</li>
                                    <li>Itching</li>
                                    <li>sore throat, or swollen lymph nodes age</li>
                                </ul>

                                <a className="links" href="https://en.wikipedia.org/wiki/Chickenpox">
                                    For More Details
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                {/*?php include 'footer.php'; ?*/}
            </>

        </PageWrapper>
    );
}

export default Chickenpox;